import { render, staticRenderFns } from "./cBreadcrumb.vue?vue&type=template&id=cc1586bc&"
import script from "./cBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./cBreadcrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports